import { ModalWrapper } from "carbon-components-react";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { deleteBeneficiaries } from "../../actions/beneficiaries";

const DeleteBeneficiariesModal = ({ beneficiary }) => {
  const dispatch = useDispatch();

  const handleFormSubmit = () => {
    const beneficiaryObject = {
      id: beneficiary.id,
    };
    dispatch(deleteBeneficiaries(beneficiaryObject));
    return true;
  };

  return (
    <div style={{ padding: "1rem" }}>
      <ModalWrapper
        aria-label="Delete Beneficiary Modal"
        buttonTriggerText="Delete Beneficiary"
        disabled={false}
        handleSubmit={handleFormSubmit}
        hasScrollingContent={false}
        id="delete-beneficiaries-modal"
        modalHeading="Delete Beneficiary"
        primaryButtonText="Delete"
        renderTriggerButtonIcon={undefined}
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        shouldCloseAfterSubmit={true}
        triggerButtonKind="ghost"
      >
        Are you sure you want to delete {beneficiary.cells[0].value}?
      </ModalWrapper>
    </div>
  );
};

DeleteBeneficiariesModal.propTypes = {
  beneficiary: PropTypes.object,
};

export default DeleteBeneficiariesModal;
